import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { DividerLine } from 'styleguide/DividerLine';
import { Spacing } from 'styleguide/spacing';
import { View } from 'styleguide/View';
import { Icon } from 'styleguide/Icons';
import { colors } from 'styleguide/colors';
import { FlexRow } from 'styleguide/Row';
import { P2 } from 'styleguide/Texts';

const Container = styled(View)`
  display: flex;
  padding: 0px ${Spacing.lg}px 0px;
  gap: ${Spacing.md}px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: ${Spacing.lg}px;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: ${Spacing.sm}px;
`;

interface ActionsProps {
  isLiked: boolean;
  onLike: () => void;
  likeCount: number;
  onComment?: () => void;
  commentCount: number;
  onShare: () => void;
  style?: CSSProperties;
  onShowLikes?: () => void;
}

export const WorkoutActions = ({
  isLiked,
  onLike,
  likeCount,
  onComment,
  commentCount,
  onShare,
  style,
  onShowLikes,
}: ActionsProps) => {
  return (
    <Container style={style}>
      <DividerLine />

      <ButtonsContainer>
        <FlexRow style={{ gap: Spacing.sm }}>
          <ButtonContainer onClick={onLike}>
            <Icon type={isLiked ? 'like-filled' : 'like'} />
          </ButtonContainer>

          <ButtonContainer onClick={onShowLikes}>
            <P2 style={isLiked ? { color: colors.primary } : undefined}>{likeCount}</P2>
          </ButtonContainer>
        </FlexRow>
        {!!onComment && (
          <ButtonContainer onClick={onComment}>
            <Icon type="comment" />
            <P2>{commentCount}</P2>
          </ButtonContainer>
        )}
        <ButtonContainer onClick={onShare}>
          <Icon type="share" />
        </ButtonContainer>
      </ButtonsContainer>
    </Container>
  );
};
